import { RouterManager } from '@aclass/admin/managers';
import { ExtraPricesStory } from '@aclass/admin/storage/actions';
import { IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class ExtraPricesCreateStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:extra-prices-create';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<boolean | null>(['extraPricesModule', 'createPageInitialized']).pipe(filter(v => v));
        this.employee = this.routerManager.onRejectNavigation(ExtraPricesCreateStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(ExtraPricesStory.dryRunCreatePage());
    }
}
